import {
  timeManager,
  CustomEvents,
  corePhasesManager,
  playersManager,
  gsap,
  modes,
  TimesTypes,
  fpsManager,
  cameraManager,
  CameraStates,
  type TournamentDataFromResultsRequest,
  type PlayerInfo
} from '@powerplay/core-minigames'
import { DisciplinePhases } from '../types'
import { StartPhaseManager } from './StartPhase/StartPhase'
import { FinishPhaseManager } from './FinishPhase/FinishPhase'
import { player } from '../entities/athlete/player'
import { RunningPhase } from './RunningPhase/RunningPhase'
import { endManager } from '../EndManager'
import { gameConfig } from '../config'
import {
  tableState,
  timeState,
  trainingResultsState
} from '@/stores'
import {
  loadingState,
  waitingState
} from '@powerplay/core-minigames-ui-ssm'
import { DrawPhaseManager } from './DrawPhase/DrawPhase'
import { FlyingPhaseManager } from './FlyingPhase/FlyingPhase'
import { timeLimitManager } from '../TimeLimitManager'
import { stateManager } from '../StateManager'

/**
 * Trieda pre spravu faz
 */
export class DisciplinePhasesManager {

  /** aktualna faza */
  public actualPhase = 0

  /** pokus */
  public attempt = 1

  /** tween na nastartovanie fazoveho managera */
  private startDisciplineTween!: gsap.core.Tween

  /** hlasitost pre divakov */
  public audienceSoundVolume = { value: 1 }

  /** Faza startu */
  public phaseStart!: StartPhaseManager

  /** Faza behu */
  public phaseRunning!: RunningPhase

  /** Faza natahovania */
  public phaseDraw!: DrawPhaseManager

  /** Faza letu */
  public phaseFlying!: FlyingPhaseManager

  /** faza konca */
  public phaseFinish!: FinishPhaseManager

  /** Flag na zistenie ci je nastavena */
  public tournamentDataSet = false

  /**
   * Vytvorenie a nastavenie veci
   */
  public create(): void {

    this.createAllPhases()

  }

  /**
   * Vytvorenie menegerov faz
   */
  public createAllPhases(): void {

    this.phaseStart = new StartPhaseManager(() => {

      this.startDisciplinePhase(DisciplinePhases.running)
      timeManager.setActive(TimesTypes.game, true)

    })

    this.phaseRunning = new RunningPhase(() => {

      this.startDisciplinePhase(DisciplinePhases.draw)

    })
    this.phaseDraw = new DrawPhaseManager(() => {

      this.startDisciplinePhase(DisciplinePhases.flying)

    })
    this.phaseFlying = new FlyingPhaseManager(() => {

      this.startDisciplinePhase(DisciplinePhases.finish)

    })

    this.phaseFinish = new FinishPhaseManager(() => {

      console.log('dispatch end')

      waitingState().isWaiting = true

      if (corePhasesManager.disciplineActualAttempt >= 1) {

        const lastAttempt = corePhasesManager.disciplineActualAttempt === corePhasesManager.disciplineAttemptsCount
        if (!modes.isTournament() || !lastAttempt) waitingState().isWaiting = false

        this.resetAttempt()

      }

      window.dispatchEvent(new CustomEvent(CustomEvents.finishDisciplinePhase))

    })

  }

  /**
   * Zistenie, ci jedna z faza je aktualna faza
   * @param phase - Pole faz na skontrolovanie
   * @returns True, ak je jedna z faz aktualna
   */
  public oneOfPhaseIsActual(phases: DisciplinePhases[]): boolean {

    return phases.includes(this.actualPhase)

  }

  public getActualPhase(): DisciplinePhases {

    return this.actualPhase

  }

  /**
   * Spustenie fazy
   * @param phase - Cislo fazy
   */
  public startDisciplinePhase(phase: DisciplinePhases): void {

    this.actualPhase = phase

    if (phase === DisciplinePhases.start) this.phaseStart.startPhase()
    if (phase === DisciplinePhases.running) this.phaseRunning.startPhase()
    if (phase === DisciplinePhases.draw) this.phaseDraw.startPhase()
    if (phase === DisciplinePhases.finish) this.phaseFinish.startPhase()

  }

  /**
   * Update aktualnej fazy kazdy frame
   */
  public update(): void {

    this.updateAudienceSound()

    if (this.actualPhase === DisciplinePhases.start) this.phaseStart.update()
    if (this.actualPhase === DisciplinePhases.running) this.phaseRunning.update()
    if (this.actualPhase === DisciplinePhases.draw) this.phaseDraw.update()
    if (this.actualPhase === DisciplinePhases.finish) this.phaseFinish.update()

  }

  /**
   * zmen hlasitost divakov podla vzdialenosti
   */
  private updateAudienceSound(): void {

    // audioManager.changeAudioVolume(AudioNames.audienceNoise, this.audienceSoundVolume.value)

  }

  /**
   * rekurzivne ukoncime vsetky fazy
   */
  public disciplinePrematureEnd = () => {

    this.actualPhase = DisciplinePhases.end
    timeLimitManager.setActive(false)
    timeState().showCountdown = false

    playersManager.setPlayerResultsDNF()

    // prejdeme si vsetky vysledky a tam kde sa nestihlo zapisat, tam zapiseme specialne vysledky
    corePhasesManager.disciplineActualAttempt = 1
    for (let i = 0; i <= corePhasesManager.disciplineAttemptsCount - 1; i += 1) {

      const result = playersManager.getPlayer().resultsArr?.[i].main ?? -1
      const secondMixedType = playersManager.getPlayer().resultsArr?.[i]?.second ?? -1
      let second = -1
      if (Array.isArray(secondMixedType)) {
        second = secondMixedType[0]
      } else {
        second = secondMixedType
      }
      // zapisujeme neuskutocneny pokus (-) iba ked uz tam neexistuje iny zapisany vysledok
      if (result <= 0 && second < 0) {

        playersManager.setPlayerResults(0, 0, 1)
        stateManager.showAttemptsTable()

      }
      corePhasesManager.disciplineActualAttempt += 1

    }

    corePhasesManager.disciplineActualAttempt = corePhasesManager.disciplineAttemptsCount

    playersManager.setStandings(2)
    console.log('STANDINGS', playersManager.getStandings())

    fpsManager.pauseCounting()

    const isFinished = false

    // posleme udaje
    endManager.sendLogEnd()
    endManager.sendSaveResult()

    // reset states
    stateManager.resetPinia(modes.isTournament() ? ['waitingState', 'blurState', 'tableState'] : [])
    loadingState().showLoading = false
    tableState().$patch({
      showTable: true,
      activeState: false,
      dataTable: [],
      isStartList: false,
    })
    waitingState().isWaiting = true

    if ((!isFinished || corePhasesManager.firstInstructions) && !modes.isTrainingMode()) {

      trainingResultsState().isDisabledPlayAgain = true

    }
    // stopneme vsetky animacne callbacky
    if (player.animationsManager) player.animationsManager.removeCallbacksFromAllAnimations()

  }

  /**
   * Nastartovanie disciplinoveho fazoveho managera
   */
  public setStartPhase = (): void => {

    // v treningu musime spravit nejake upravy, aby vsetko fungovalo ako malo
    if (modes.isTrainingMode()) {

      player.updateBeforePhysics(disciplinePhasesManager.actualPhase)
      player.updateCameraConfigOnStart(CameraStates.intro)
      if (gameConfig.cameraConfig.enabled) player.setGameCameraSettings()
      cameraManager.setState(CameraStates.intro)
      // cameraManager.playTween(false, this.phaseStart.secondCameraDisciplineIntro)

    }

    if (modes.isTutorial() && corePhasesManager.disciplineActualAttempt === 1) {

      this.startStartPhase()
      return

    }

    // musime tu dat mensi delay, lebo mozeme skipovat este nejake fazy predtym
    this.startDisciplineTween = gsap.to({}, {
      duration: modes.isTutorial() ? 0.01 : 0.01,
      onComplete: () => {

        this.startStartPhase()

      }
    })

  }

  /**
   * Spustenie start phase
   */
  private startStartPhase(): void {

    const phase = DisciplinePhases.start
    this.startDisciplinePhase(phase)

  }

  /**
   * resetovanie hry
   * @param resetAttempts - Ci ma byt tvrdy reset aj s poctom pokusov
   */
  public resetAttempt(resetAttempts = false): void {

    console.log('reseting attempt')

    this.phaseStart.reset()
    this.phaseDraw.reset()
    this.phaseRunning.reset()
    this.phaseFlying.reset()
    this.phaseFinish.reset()
    timeLimitManager.reset()

    player.reset()

    timeManager.reset()

  }


  /**
   * Inputy pri behu
   */
  public handleInputs(): void {

    if (this.actualPhase === DisciplinePhases.start) this.phaseStart.handleInputs()
    if (this.actualPhase === DisciplinePhases.running) this.phaseRunning.handleInputs()
    if (this.actualPhase === DisciplinePhases.finish) this.phaseFinish.handleInputs()

  }

  /**
   * Checker ci je prvy pokus
   * @returns ci je akurat ten prvy pokus
   */
  public isFirstAttempt(): boolean {

    return corePhasesManager.disciplineActualAttempt === 1

  }

  /**
   * Checker ci je prvy pokus v skupine
   * @returns ci je akurat ten prvy pokus
   */
  public isFirstAttemptInGroup(): boolean {

    return (corePhasesManager.disciplineActualAttempt - 1) % corePhasesManager.provisionalResultsFrequency === 0

  }

  /**
   * Nastavenie dat o hracoch
   * @param dataCallback - funkcia na ukladanie
   */
  public setOpponentsForFinishTable(dataCallback: TournamentDataFromResultsRequest): void {

    const newPlayersData: PlayerInfo[] = []
    let index = 0
    dataCallback.players.forEach((playerInfo) => {

      playerInfo.attribute = {
        base: 0,
        total: 0
      }

      if (playerInfo.uuid === player.uuid) playerInfo.playable = true

      // musime zarucit, ze hrac bude aj tu prvy
      if (!playerInfo.playable) index += 1
      newPlayersData[playerInfo.playable ? 0 : index] = playerInfo

    })

    playersManager.players = newPlayersData

    // musime este upravit data pre hraca, kedze sa vyssim priradenim dali na DNF
    playersManager.players[0].resultsArr = playersManager.players[0].resultsArrOriginal

    this.tournamentDataSet = true

    waitingState().isWaiting = false
    tableState().activeState = true

    window.dispatchEvent(new CustomEvent(CustomEvents.startFinalStandingsPhase))

  }

  /**
   * Reinstancovanie manazerov
   */
  public reset(): void {

    this.createAllPhases()
    this.resetAttempt(true)
    endManager.prematureEnded = false

  }

}

export const disciplinePhasesManager = new DisciplinePhasesManager()
